import moment from 'moment'

export default function(filterLocalDateAtMidnight, cellValue) {
  const dateValue = (moment.isMoment(cellValue) ? cellValue : moment(cellValue)).startOf('day')
  const comparisonDate = moment(filterLocalDateAtMidnight).startOf('day')

  // Check for invalid dates
  if (!dateValue.isValid() || !comparisonDate.isValid()) {
    return 0
  }

  // Use Moment.js comparison methods
  if (dateValue.isBefore(comparisonDate)) {
    return -1
  } else if (dateValue.isAfter(comparisonDate)) {
    return 1
  } else {
    return 0
  }
}
